module.exports = __webpack_public_path__ + "static/img/7.fce67d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/7.png
// module id = 5q8y
// module chunks = 0